(function () {
  'use strict';

  var MESSAGE_INTERVAL_MS = 4000;
  var SWIPE_THRESHOLD = 40;
  var WISHLIST_KEY = 'joselito-wishlist';
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  function prefersReducedMotion() {
    return reducedMotion.matches;
  }

  function readWishlist() {
    try {
      var raw = window.localStorage.getItem(WISHLIST_KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      return Array.isArray(parsed) ? parsed.map(String) : [];
    } catch (error) {
      return [];
    }
  }

  function writeWishlist(ids) {
    try {
      window.localStorage.setItem(WISHLIST_KEY, JSON.stringify(ids));
    } catch (error) {
      /* ignore quota / private mode */
    }
  }

  function bindGallery(root) {
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-slide]'));
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-thumb]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-dot]'));
    var stage = root.querySelector('[data-hero-product-stage]');
    if (slides.length < 2) return;

    var index = 0;

    function pauseVideos() {
      slides.forEach(function (slide, i) {
        var video = slide.querySelector('video');
        if (!video) return;
        if (i === index) {
          if (!prefersReducedMotion()) video.play().catch(function () {});
        } else {
          video.pause();
        }
      });
    }

    function goTo(next) {
      var max = slides.length;
      index = ((next % max) + max) % max;
      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });
      thumbs.forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === index);
        thumb.setAttribute('aria-pressed', i === index ? 'true' : 'false');
      });
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === index);
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      pauseVideos();
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () {
        goTo(i);
      });
    });

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        goTo(i);
      });
    });

    if (stage) {
      var startX = 0;
      var startY = 0;
      var tracking = false;

      stage.addEventListener(
        'touchstart',
        function (event) {
          if (!event.changedTouches || !event.changedTouches[0]) return;
          startX = event.changedTouches[0].clientX;
          startY = event.changedTouches[0].clientY;
          tracking = true;
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchmove',
        function (event) {
          if (!tracking || !event.touches || !event.touches[0]) return;
          var dx = Math.abs(event.touches[0].clientX - startX);
          var dy = Math.abs(event.touches[0].clientY - startY);
          if (dx > 8 && dx > dy) {
            event.preventDefault();
          }
        },
        { passive: false }
      );

      stage.addEventListener(
        'touchend',
        function (event) {
          if (!tracking) return;
          tracking = false;
          if (!event.changedTouches || !event.changedTouches[0]) return;
          var deltaX = event.changedTouches[0].clientX - startX;
          var deltaY = event.changedTouches[0].clientY - startY;
          if (Math.abs(deltaX) < SWIPE_THRESHOLD || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          goTo(index + (deltaX < 0 ? 1 : -1));
        },
        { passive: true }
      );

      stage.addEventListener(
        'touchcancel',
        function () {
          tracking = false;
        },
        { passive: true }
      );
    }

    goTo(0);
  }

  function bindDescription(root) {
    var body = root.querySelector('[data-hero-product-description]');
    var button = root.querySelector('[data-hero-product-more]');
    if (!body || !button) return;

    var expandLabel = button.getAttribute('data-label-more') || '';
    var collapseLabel = button.getAttribute('data-label-less') || '';
    var MAX_LINES = 3;

    function countLines() {
      var width = Math.ceil(body.getBoundingClientRect().width);
      if (width < 8) return 0;

      var parent = body.parentNode;
      if (!parent) return 0;

      var clone = body.cloneNode(true);
      clone.removeAttribute('data-hero-product-description');
      clone.classList.remove('is-expanded');
      clone.setAttribute('aria-hidden', 'true');
      clone.style.cssText = [
        'position:absolute',
        'left:0',
        'top:0',
        'visibility:hidden',
        'pointer-events:none',
        'display:block',
        'height:auto',
        'max-height:none',
        'overflow:visible',
        '-webkit-box-orient:initial',
        '-webkit-line-clamp:unset',
        'line-clamp:unset',
        'width:' + width + 'px'
      ].join(';');
      parent.appendChild(clone);

      var range = document.createRange();
      range.selectNodeContents(clone);
      var rects = range.getClientRects();
      var lines = rects.length;
      parent.removeChild(clone);
      return lines;
    }

    function needsToggle() {
      if (body.classList.contains('is-expanded')) return true;
      return countLines() > MAX_LINES;
    }

    function sync() {
      var show = needsToggle();
      button.classList.toggle('is-visible', show);
      button.hidden = !show;
      if (!show && body.classList.contains('is-expanded')) {
        body.classList.remove('is-expanded');
        button.setAttribute('aria-expanded', 'false');
        button.textContent = expandLabel;
      }
    }

    button.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-expanded');
      button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      button.textContent = expanded ? collapseLabel : expandLabel;
      if (!expanded) {
        window.requestAnimationFrame(sync);
      }
    });

    sync();
    window.requestAnimationFrame(function () {
      sync();
      window.requestAnimationFrame(sync);
    });
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(sync).catch(function () {});
    }
    window.addEventListener('resize', sync);
  }

  function bindMessages(root) {
    var items = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-promise]'));
    if (items.length < 2) return;

    var index = 0;
    var timer = null;

    function show(next) {
      index = next % items.length;
      items.forEach(function (item, i) {
        item.classList.toggle('is-active', i === index);
      });
    }

    function start() {
      stop();
      if (prefersReducedMotion()) return;
      if (window.matchMedia('(min-width: 1024px)').matches === false) return;
      timer = window.setInterval(function () {
        show(index + 1);
      }, MESSAGE_INTERVAL_MS);
    }

    function stop() {
      if (timer) {
        window.clearInterval(timer);
        timer = null;
      }
    }

    show(0);
    start();
    window.addEventListener('resize', start);
    reducedMotion.addEventListener('change', start);
  }

  function bindWishlist(root) {
    var button = root.querySelector('[data-hero-product-wishlist]');
    if (!button) return;

    var productId = root.getAttribute('data-product-id') || '';
    var persist = root.getAttribute('data-wishlist-persist') === 'true';
    var addLabel = button.getAttribute('data-label-add') || '';
    var addedLabel = button.getAttribute('data-label-added') || '';

    function setState(on) {
      root.classList.toggle('is-wishlisted', on);
      button.setAttribute('aria-pressed', on ? 'true' : 'false');
      button.textContent = on ? addedLabel : addLabel;
    }

    if (persist && productId) {
      setState(readWishlist().indexOf(productId) !== -1);
    } else {
      setState(root.classList.contains('is-wishlisted'));
    }

    button.addEventListener('click', function () {
      var next = !root.classList.contains('is-wishlisted');
      setState(next);
      if (!persist || !productId) return;
      var ids = readWishlist().filter(function (id) {
        return id !== productId;
      });
      if (next) ids.push(productId);
      writeWishlist(ids);
    });
  }

  function bindDock(root) {
    var dock = root.querySelector('[data-hero-product-dock]');
    var cta = root.querySelector('[data-hero-product-cta]');
    if (!dock || !cta) return;

    var desktopMq = window.matchMedia('(min-width: 1024px)');
    var footer = document.querySelector('[data-footer]');
    var DOCK_GAP = 24;

    function sync() {
      var rect = cta.getBoundingClientRect();
      var visible;
      if (desktopMq.matches) {
        /* Desktop: only after scrolling past the main CTA. */
        visible = rect.bottom < 0;
      } else {
        /* Mobile: CTA starts below the fold — show dock until it enters view. */
        visible = rect.bottom <= 0 || rect.top >= window.innerHeight;
      }

      /* Lift the dock so it stays above the footer instead of overlapping it. */
      var bottom = DOCK_GAP;
      if (footer) {
        var overlap = window.innerHeight - footer.getBoundingClientRect().top;
        if (overlap > 0) bottom = DOCK_GAP + overlap;
      }
      dock.style.bottom = bottom + 'px';

      dock.classList.toggle('is-visible', visible);
    }

    sync();
    window.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', sync);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(sync);
    }
  }

  function bindVariants(root) {
    var dialog = root.querySelector('[data-hero-product-variants]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-open-variants]'));
    var closers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-variants-close]'));
    var radios = Array.prototype.slice.call(dialog.querySelectorAll('[data-hero-product-variant-price]'));
    var dockPrice = root.querySelector('[data-hero-product-dock-price]');
    var mainCta = root.querySelector('[data-hero-product-cta]');

    function open() {
      if (!dialog.open) dialog.showModal();
    }

    function close() {
      if (dialog.open) dialog.close();
    }

    function syncPrices(input) {
      if (!input) return;
      var price = input.getAttribute('data-hero-product-variant-price') || '';
      if (dockPrice && price) dockPrice.textContent = price;
      if (mainCta && price && !mainCta.disabled && mainCta.getAttribute('data-hero-product-open-contact') === null) {
        var template = mainCta.getAttribute('data-label-choose');
        if (template) {
          mainCta.textContent = template.split('__PRICE__').join(price);
        }
      }
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        open();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) close();
    });

    radios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) syncPrices(radio);
      });
    });

    var checked = dialog.querySelector('[data-hero-product-variant-price]:checked');
    if (checked) syncPrices(checked);
  }

  function bindContact(root) {
    var overlay = root.querySelector('[data-hero-product-contact]');
    if (!overlay) return;

    var openers = Array.prototype.slice.call(root.querySelectorAll('[data-hero-product-open-contact]'));
    var closers = Array.prototype.slice.call(overlay.querySelectorAll('[data-hero-product-contact-dismiss]'));
    var closeBtn = overlay.querySelector('[data-hero-product-contact-close]');

    function open() {
      overlay.hidden = false;
      document.body.classList.add('is-hero-product-contact-open');
      if (closeBtn) closeBtn.focus();
    }

    function close() {
      overlay.hidden = true;
      document.body.classList.remove('is-hero-product-contact-open');
    }

    openers.forEach(function (btn) {
      btn.addEventListener('click', function () {
        open();
      });
    });

    closers.forEach(function (btn) {
      btn.addEventListener('click', close);
    });

    document.addEventListener('keydown', function (event) {
      if (overlay.hidden) return;
      if (event.key !== 'Escape') return;
      event.preventDefault();
      close();
    });
  }

  function bind(root) {
    if (!root || root._heroProductBound) return;
    root._heroProductBound = true;
    bindGallery(root);
    bindDescription(root);
    bindMessages(root);
    bindWishlist(root);
    bindDock(root);
    bindVariants(root);
    bindContact(root);
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-hero-product]').forEach(bind);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) init(event.target);
  });
})();
